const CHUAN_ITEMS = [
  {
    time: "第1集",
    title: "破圈初登场",
    desc: "老熟人空降舞台开场，弹幕惊呼“居然是他”，热度瞬间登顶分类榜。",
    icon: "ri-shining-line",
  },
  {
    time: "第2集",
    title: "互动放大镜",
    desc: "座位安排与即兴搭话被逐帧分析，两拨粉丝圈开始隔空对线。",
    icon: "ri-search-eye-line",
  },
  {
    time: "第3集",
    title: "后续跟进",
    desc: "官方释出幕后花絮自证默契，事件热度从争吵转向期待二搭。",
    icon: "ri-restart-line",
  },
];

export default function ChuanSection() {
  return (
    <section
      id="chuan"
      className="scroll-mt-20 bg-background-100/60 py-10 md:py-14"
    >
      <div className="container-x">
        <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
              <span className="h-px w-6 bg-primary-400" /> DROPPING IN
            </p>
            <h2 className="mt-2 font-display text-2xl text-foreground-900 md:text-3xl">
              串门瓜 · 一次串门引发的跨圈动静
            </h2>
          </div>
          <p className="max-w-md text-sm text-foreground-600">
            从破圈首秀到二搭期待，小编把某位熟脸“串门”进别家舞台的整条线拆给你看。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
          <div className="relative h-64 w-full overflow-hidden rounded-3xl lg:col-span-2 lg:h-auto">
            <img
              src="https://readdy.ai/api/search-image?query=Behind-the-scenes%20concert%20venue%20after%20a%20show%2C%20warm%20spotlight%20beams%20cutting%20through%20stage%20haze%2C%20silhouette%20of%20performers%20leaving%20stage%2C%20editorial%20documentary%20photography%20with%20warm%20amber%20tones%20and%20crowd%20silhouettes%2C%20cinematic%20lighting%20atmosphere&width=900&height=1000&seq=chuan-hero-2026&orientation=portrait"
              alt="演出后台散场与串门嘉宾的画面"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4 right-4">
              <span className="whitespace-nowrap rounded-full bg-background-50/90 px-3 py-1 text-xs text-foreground-700">
                #串门全记录
              </span>
              <h3 className="mt-2 font-display text-lg leading-snug text-background-50">
                从“他怎么来了”到“他俩配一脸”，一场串门热度走势复盘
              </h3>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:col-span-3 lg:grid-cols-1 xl:grid-cols-3">
            {CHUAN_ITEMS.map((it, i) => (
              <article
                key={it.title}
                className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-5 transition-transform hover:-translate-y-1"
              >
                <span className="font-display text-3xl text-background-300">
                  0{i + 1}
                </span>
                <span className="mt-2 inline-flex h-10 w-10 items-center justify-center rounded-xl bg-primary-100 text-lg text-primary-600">
                  <i className={it.icon} />
                </span>
                <p className="mt-3 text-xs text-primary-600">{it.time}</p>
                <h3 className="mt-1 font-medium text-foreground-900">{it.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{it.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}